import { useState, useEffect } from 'react';

export default function InstallButton() {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    const checkPWAStatus = async () => {
      console.log('--- PWA DIAGNOSTICS ---');
      console.log('1. Display Mode:', window.matchMedia('(display-mode: standalone)').matches ? 'standalone' : 'browser');
      
      if ('serviceWorker' in navigator) {
        const registration = await navigator.serviceWorker.getRegistration();
        console.log('2. SW Registration:', registration ? 'Found' : 'Missing', registration);
        console.log('3. SW Controller:', navigator.serviceWorker.controller ? 'Active' : 'None');
      } else {
        console.log('2. Service Worker: Not supported');
      }
      console.log('-----------------------');
    };
    
    checkPWAStatus();

    // Verify standalone mode
    const isStandaloneMode = window.matchMedia('(display-mode: standalone)').matches || 
                             (window.navigator as any).standalone;
    setIsStandalone(isStandaloneMode);

    const handler = (e: any) => {
      console.log('✅ beforeinstallprompt success!', e);
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
      if (import.meta.env.DEV) {
        const sw = navigator.serviceWorker.controller;
        alert(`Estado PWA (Dev):\n\nEvento Prompt: NO disparado\nSW Controller: ${sw ? 'ACTIVO' : 'INACTIVO'}\n\nSi el SW está inactivo, recarga la página. Si está activo, Chrome puede pensar que ya está instalada o no ha detectado interacción suficiente.`);
      }
      return;
    }

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {
      setDeferredPrompt(null);
    }
  };

  // En DEV mostramos el botón para depurar posición
  if (isStandalone || (!deferredPrompt && !import.meta.env.DEV)) {
    return null;
  }

  return (
    <button
      onClick={handleInstallClick}
      className={`px-3 py-1.5 bg-slate-100 text-slate-600 rounded-lg hover:bg-slate-200 transition flex items-center gap-2 text-sm font-medium border border-slate-200 ${!deferredPrompt ? 'opacity-50' : ''}`}
      title="Instalar aplicación"
    >
      <i className="ri-download-line text-lg"></i>
      <span className="hidden sm:inline">Instalar App</span>
    </button>
  );
}
